import { api } from 'services/api';

export class BudgetService {
  async getPendingBudget(data = {}) {
    return api.get(`/budget/`, { params: data });
  }

  async getBudgetModels() {
    return api.get('/budget/models');
  }

  async getBudgetAdditionalServices(payload) {
    return api.get('/budget/additional-services', { params: payload });
  }

  async getBudgetParts(payload) {
    return api.get('/budget/parts', { params: payload });
  }

  async createTemplate(payload) {
    return api.post('/budget/template', payload, {
      responseType: 'arraybuffer',
    });
  }

  async generatePayment(payload) {
    return api.post('/budget/generate-payment', payload);
  }

  async saveBudget(payload) {
    return api.post('/budget/save', payload);
  }

  async getBudgetObservations(budgetId) {
    return api.get(`/budget/observations/${budgetId}`);
  }

  async saveBudgetObservation(payload) {
    return api.post('/budget/observations', payload);
  }
}

export const budgetService = new BudgetService();
